import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../shared/translation/i18n';
import { MAX_BRAND_SELECTION } from '../../../common/constants';
import { enArticle } from '../../../common/data/enArticle';
import { frArticle } from '../../../common/data/frArticle';
import { getTypeCategoryFromDisplay } from '../../../common/data/getTypeCategoryFromDisplay';
import { ITEM_TYPES } from '../../../common/data/itemTypes2';
import { Brand } from '../../../common/types';
import BrandSearchInput from '../../inputs/BrandSearchInput';
import PrimaryParagraph from '../../texts/PrimaryParagraph';
import PrimaryTitle from '../../texts/PrimaryTitle';
import { BrandSelectionViewProps } from '../types';

const BrandSelectionView: FC<BrandSelectionViewProps> = (props) => {
	console.debug("[BrandSelectionView] rendered!");
	const { t } = useTranslation();
	const typeCategory = getTypeCategoryFromDisplay(props.typeLabelDisplay)?.raw;
	if (!typeCategory) {
	return null; // or show a fallback UI
}
	const localizedCategoryLabel = t(`type_category.${typeCategory}.singular`);
	
	const matchingItem = ITEM_TYPES.find(
	(item) => item.type_label_display === props.typeLabelDisplay
	);

	const gender = matchingItem?.fr_gender ?? 'm';
	const vowelSound = matchingItem?.fr_vowel_sound ?? false;

	const article = frArticle('definite', gender, vowelSound);


	const handleBrandSelection = (brand: Brand) => {
		if (props.selectedBrands.some((b) => b.code === brand.code)) {
			props.setSelectedBrands(props.selectedBrands.filter((b) => b.code !== brand.code));
		} else if (props.selectedBrands.length < MAX_BRAND_SELECTION) {
			props.setSelectedBrands([...props.selectedBrands, brand]);
		} else {
			// setError(`You can only select up to ${MAX_BRAND_SELECTION} brands.`);  // TODO: set but never displayed?!?
		}
	};

	const isSelected = (brandCode: string) => {
		return props.selectedBrands.map((brand) => brand.code).includes(brandCode);
	};

	return (
		<div className={'pop-h-full pop-fadeIn pop-my-4'}>
			<div className={'pop-flex pop-flex-col pop-w-full pop-items-center'}>
				<PrimaryTitle className="pop-text-center pop-mb-2">{t('closet_question')}</PrimaryTitle>

				<PrimaryParagraph className={'pop-text-center pop-mb-4 pop-text-popsizePrimary50'}>
					{t('closet_sentence_start')}
					<span className="pop-font-bold">
						{/*{getTypeCategoryFromDisplay(props.typeLabelDisplay).localized}*/}
						{i18n.language === 'fr'
						? `${article} ${localizedCategoryLabel.toLowerCase()}`
						: `${enArticle(localizedCategoryLabel.toLowerCase())} ${localizedCategoryLabel.toLowerCase()}`}
					</span>
					{t('closet_sentence_end')}
				</PrimaryParagraph>
				<BrandSearchInput
					onBrandSelect={handleBrandSelection}
					selectedBrands={props.selectedBrands}
					setSelectedBrands={props.setSelectedBrands}
					isSelected={isSelected}
					partnerId={props.partnerId}
				/>
			</div>
		</div>
	);
};

export default BrandSelectionView;
